//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  layout: 'marketing-page',
  head() {
    return {
      title: 'Inventory & BOM Management with Octopart Integration | BOMIST',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            "Search Octopart's database of 40M+ parts directly from BOMIST. Get live pricing and availability for your BOM components without leaving your inventory workflow."
        }
      ]
    };
  }
};
